import type { ApplicationRepository } from '#/domain/application/ApplicationRepository'
import type { Application } from '#/domain/application/Application'
import type { HttpClientPort } from '#/infrastructure/persistence/HttpClientPort'
import { parseApplications, type InvalidApplication } from './parseApplications'

export class HttpApplicationRepository implements ApplicationRepository {
  constructor(
    private readonly http: HttpClientPort,
    private readonly onInvalid?: (invalid: InvalidApplication) => void,
  ) {}

  async findAll(): Promise<Application[]> {
    const raw = await this.http.get<unknown>('v1/application')
    return parseApplications(raw, this.onInvalid)
  }
}
